var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex"},[_c('div',{ref:"leftPanel",staticClass:"leftPanel"},[_vm._t("sidebar")],2),_c('div',{ref:"border",staticClass:"border"}),_c('div',{staticClass:"content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }